const TRANSPORT_FEE_URI_PREFIX = "/v1/route";
export const TRANSPORT_FEE_URIS = {
    // EXPORT_LIST_TRANSPORT_FEE: `${TRANSPORT_FEE_URI_PREFIX}/export`,
    EXPORT_LIST_TRANSPORT_FEE: `/v2/routes/export-data-correction`,
}

export default {
    exportListTransportFee(params) {
        const searchParams = new URLSearchParams(params);
        const link = `${TRANSPORT_FEE_URIS.EXPORT_LIST_TRANSPORT_FEE}?${searchParams.toString()}`;
        window.open(link);
        console.log("params", params);
    },
}


// WEBPACK FOOTER //
// ./src/services/transport-fee-service.js